export class NotificationDto {
    id!: number;
    type!: string;
    title!: string;
    message!: string;
    url!: string;
    metadata?: Record<string, unknown> | null;
    created_at!: string;
    read_at?: string | null;
}

export type UnreadCountDto = {
    count: number;
};

export type DismissAllNotificationsDto = {
    dismissed: number;
    marked_read: number;
};
